import React from 'react'
import Section from '../../../Utilitis/Section'
import { Col, Container, Row } from 'react-bootstrap'
import TitleSection from '../../../Utilitis/TitleSection'
import CourseCategorie from '../../../Utilitis/CourseCategorie/CourseCategorie'


export default function CouresesCategorie() {
    return (
        <Section bg="#f3f7f9">
            <Container>
                <TitleSection text="Courses Categorie" center title />
                <Row>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="Web desgin" image="/images/slide_1.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="Web devlope" image="/images/slide-2.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="App desgin" image="/images/slide_1.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="App desgin" image="/images/slide-2.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="Web desgin" image="/images/slide_1.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="Web devlope" image="/images/slide-2.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="App desgin" image="/images/slide_1.jpg" /></Col>
                    <Col lg={3} md={4} sm={6} xs={12}> <CourseCategorie title="App desgin" image="/images/slide-2.jpg" /></Col>
                </Row>
            </Container>
        </Section>
    )
}
